export const regulations = {
    'meta': {
        'title': 'Regulamin Centrum Psychiatrii i Psychoterapii COLLIGO #cityLocativeIn#',
        'description': 'Szczegółowy regulamin obowiązujący w Centrum Psychiatrii i Psychoterapii COLLIGO #cityLocativeIn#'
    },
    'url': {
        'address': '/regulamin/',
        'title': 'Regulamin Centrum Psychiatrii i Psychoterapii COLLIGO',
        'name': 'Regulamin'
    },
    'opengraph': {
        'image': {
            'url': null,
            'width': 150,
            'height': 150,
            'alt': 'Szczegółowy regulamin obowiązujący w Centrum Psychiatrii i Psychoterapii COLLIGO #cityLocativeIn#'
        }
    }
}